<template>
  <v-container fluid class="pa-0 pa-sm-3">
    <!-- dialog for employee to mark as submitted doc -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card v-if="currentEmployee">
        <v-card-title class="headline"
          >{{ currentEmployee.firstName }} {{ currentEmployee.lastName }} - Mark
          as Submitted</v-card-title
        >
        <!--  -->
        <v-card-text>
          This will mark employee
          <strong
            >{{ currentEmployee.firstName }}
            {{ currentEmployee.lastName }}</strong
          >
          as having submitted the required document.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="markAsSubmitted()"
            >Document Submitted</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row wrap class="justify-left">
      <v-col cols="12" xs="12" class="headline pb-0"
        >Recent Punch-Ins by Employees with Missing Documents
        <span class="caption">count: {{ punchIns.length }}</span></v-col
      >
      <v-col cols="12" xs="12" sm="12" md="10">
        <v-card>
          <v-data-table
            :items="punchIns"
            :loading="loadingEmployees"
            loading-text="Loading....please wait."
            :headers="headers"
            :items-per-page="200"
            hide-default-footer
            sort-by="count"
            sort-desc
            dense
          >
            <template v-slot:item.employee.firstName="{ item }">
              {{ item.employee.firstName }} {{ item.employee.lastName }}
            </template>
            <template v-slot:item.jobSite="{ item }">
              {{ item.jobSite.address }}
            </template>
            <template v-slot:item.time="{ item }">
              {{ item.time.toDate() | moment("MMM Do h:mma") }}
            </template>
            <template v-slot:item.button="{ item }">
              <v-btn
                color="primary"
                text
                outlined
                small
                @click="openDialog(item.employee)"
                >mark as submitted</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
        <br /><br /><br />
        <v-col cols="12" xs="12" class="headline pb-0"
          >All Employees Missing Documents (Not punched in today)
          <span class="caption"
            >count: {{ employeesFiltered.length }}</span
          ></v-col
        >
        <v-card>
          <!--  simple table of all employees -->
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr v-for="employee in employeesFiltered" :key="employee.docId">
                  <td class="" width="200px">
                    {{ employee.firstName }} {{ employee.lastName }}
                  </td>
                  <td class="">
                    {{ employee.department }}
                  </td>
                  <td class=""></td>
                  <td class="text-right">
                    <v-btn
                      color="primary"
                      text
                      outlined
                      small
                      @click="openDialog(employee)"
                      >mark as submitted</v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import fb from "@/main";
import { mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      punchIns: [],
      loadingEmployees: true,
      currentEmployee: null,
      dialog: false,
      allEmployees: [],
      headers: [
        { text: "Name", value: "employee.firstName" },
        { text: "Code", value: "employee.department" },
        { text: "Job Site", value: "jobSite" },
        { text: "Punch In", value: "time" },
        { text: "", value: "button" },
      ],
    };
  },
  computed: {
    ...mapState(["jobSites", "payroll", "employees"]),
    employeesFiltered() {
      // first find all employees with missing documents from payroll
      const missingDocs = this.payroll.filter((emp) => emp.missingDocuments);
      // then combine with employees array
      // filter out employees from punchIns
      return this.employees.filter(
        (emp) =>
          missingDocs.find((doc) => doc.docId === emp.docId) &&
          !this.punchIns.find((punch) => punch.employee.docId === emp.docId)
      );
    },
  },
  async created() {
    // move to method
    this.init();
  },
  methods: {
    openDialog(employee) {
      this.currentEmployee = employee;

      this.dialog = true;
    },
    async markAsSubmitted() {
      try {
        await fb.db
          .collection("payroll")
          .doc(this.currentEmployee.docId)
          .update({ missingDocuments: false });
        //close dialog
        this.dialog = false;
        //reload data
        this.init();
      } catch (error) {
        alert("Error marking as submitted.");
        console.log(error);
      }
    },
    async init() {
      this.loadingEmployees = true;
      this.punchIns = [];
      await this.$store.dispatch("getPayroll", fb);
      await this.$store.dispatch("getEmployees", fb);
      try {
        const punRes = await fb.db
          .collection("punchRecords")
          .where(
            "time",
            ">",
            // start of today
            moment()
              .startOf("day")
              .toDate()
          )
          .get();

        // Iterate through punchRecords and process them
        punRes.forEach((doc) => {
          const data = doc.data();
          const punchRecords = {
            id: doc.id,
            ...data,
          };
          //skip if punchRecords.direction == 'out'
          if (punchRecords.direction === "out") {
            return;
          }

          // Find and add job site data
          const jobSite = this.jobSites.find(
            (site) => site.id === punchRecords.jobSite
          );
          punchRecords.jobSite = jobSite;

          // Find and add employee data
          const payroll = this.payroll.find(
            (emp) => emp.docId === punchRecords.employee
          );
          punchRecords.payroll = payroll;

          //find employee data
          const employee = this.employees.find(
            (emp) => emp.docId === punchRecords.employee
          );
          punchRecords.employee = employee;

          //filter where punchRecords.direction == 'in'
          if (punchRecords.punchDirection === "out") {
            return;
          }

          // Filter only if employee has missing documents
          if (payroll && payroll.missingDocuments) {
            this.punchIns.push(punchRecords);
            //reverse the array
            this.punchIns.reverse();
          }
        });

        this.loadingEmployees = false;
      } catch (error) {
        alert("Error loading punch records.");
        console.log(error);
        this.loadingEmployees = false;
      }
    },
  },
};
</script>
